<template>
  <div class="deal-config">
    <!-- <div>配置列表</div> -->

    <el-card class="table-card">
      <div style="border-bottom:1px solid #f5f5f5">
        <el-row class="grid-content">
          <el-col :span="20" :offset="3">
            <el-menu :default-active="selectAnomalyCode" class="el-menu-demo" mode="horizontal" @select="handleCurrentChange">
              <el-menu-item v-for="item in nameList" :index="item.anomalyCode" :key="item.type">{{ item.name }}</el-menu-item>
            </el-menu>
          </el-col>
        </el-row>
      </div>

      <div style="height: calc(100vh - 210px)">
        <el-row style="margin-bottom:10px">
          <el-col :span="5">
            <el-button v-if="permission.btn_eventProcessConfig_add" type="primary" :disabled="disabledAdd" size="small" @click="addItem()" style="height:30px;margin-top: 10px;">新增</el-button>
          </el-col>
        </el-row>

        <div class="grid-content">
          <el-table :data="dealList" style="width: 100%;height:100%" :maxHeight="674">
            <el-table-column label="序号" type="index" width="60"></el-table-column>
            <el-table-column label="处理方式" min-width="500">
              <template slot-scope="scope">
                <el-input v-if="scope.row.isEdit" v-model.trim="scope.row.processMode" placeholder="处理方式" :maxlength="100" show-word-limit></el-input>
                <span v-else>{{ scope.row.processMode }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="140">
              <template slot-scope="scope">
                <el-button v-if="!scope.row.isEdit && permission.btn_eventProcessConfig_edit" @click="updateHandleMethodStatus(scope.row, scope.$index)" type="text" size="small">编辑</el-button>
                <el-button v-if="scope.row.isEdit && scope.row.id && permission.btn_eventProcessConfig_edit" @click="updateHandleMethod(scope.row)" type="text" size="small">保存</el-button>
                <el-button v-if="scope.row.isEdit && !scope.row.id && permission.btn_eventProcessConfig_add" @click="addHandleMethod(scope.row, scope.$index)" type="text" size="small"
                  >保存新增</el-button
                >
                <el-button class="btn-del" v-if="permission.btn_eventProcessConfig_del" @click="deleteHandleMethod(scope.row, scope.$index)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-card>
  </div>
</template>
<script>
export default {
  data() {
    return {
      nameList: [
        { name: "逾期开工（工单/工序）", type: 0, anomalyCode: "starts_overdue" },
        { name: "完工逾期（工单/工序）", type: 1, anomalyCode: "complete_overdue" },
        { name: "在制品呆滞", type: 5, anomalyCode: "product_dull" },
        { name: "在制品积压", type: 6, anomalyCode: "product_overstock" },
        { name: "母卷质量检超时", type: 7, anomalyCode: "first_check_overtime" },
        { name: "子卷质量检超时", type: 8, anomalyCode: "patrol_check_overtime" },
        { name: "自检超时", type: 9, anomalyCode: "self_check_overtime" },
        { name: "点检超时", type: 10, anomalyCode: "spot_inspection_delay" },
        { name: "其他异常", type: 11, anomalyCode: "other_anomalies" }
      ],

      selectAnomalyCode: "starts_overdue",
      dealList: [],
      disabledAdd: false,
      permission: JSON.parse(localStorage.getItem("permission"))
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loadHandleMethod(this.selectAnomalyCode);
    },
    // 切换事件类型
    async handleCurrentChange(val) {
      //测试数据
      log(val);
      this.selectAnomalyCode = val;
      this.loadHandleMethod(val);
    },
    // 新增事件处理方式
    addHandleMethod(rowData, fn) {
      if (!rowData.processMode) {
        this.$message.warning("处理方式不能为空");
        return;
      }
      let find = this.dealList.find(item => item.processMode == rowData.processMode && item.id);
      if (find) {
        this.$message.warning("处理方式名称不能相同");
        return;
      }
      rowData.isEdit = false;
      this.disabledAdd = false;
      rowData.id = parseInt(Math.random() * 1000);
      this.$RequestUtil.post({
        url: "/api/eventProcessConfig/add",
        type: "sync",
        params: {
          processMode: rowData.processMode,
          anomalyCode: this.selectAnomalyCode
        },
        success: async res => {
          rowData.isEdit = false;
          this.disabledAdd = false;
          this.$message.success("新增成功");
          this.loadHandleMethod(this.selectAnomalyCode);
        }
      });
    },
    rowClass({ row, columnIndex }) {
      if (row.anomalyCode == this.selectAnomalyCode) {
        return { "background-color": "rgb(109, 183, 238)", cursor: "pointer" };
      } else {
        return { cursor: "pointer" };
      }
    },

    addItem() {
      log(this.dealList, 1234);
      this.dealList.push({ isEdit: true, processMode: "" });
      this.disabledAdd = true;
    },

    updateHandleMethodStatus(rowData, index) {
      let find = this.dealList.find(item => item.isEdit);
      if (find) {
        this.$message.warning("当前存在未保存的处理方式，请先保存后编辑下一项！");
        return;
        if (!find.processMode) {
        } else {
          this.updateHandleMethod(find, () => {
            this.dealList.forEach(item => {
              item.isEdit = false;
            });
            this.disabledAdd = true;
            this.$set(this.dealList[index], "isEdit", true);
          });
        }
      } else {
        this.dealList.forEach(item => {
          item.isEdit = false;
        });
        this.disabledAdd = true;
        this.$set(this.dealList[index], "isEdit", true);
      }
    },
    // 修改事件处理方式
    updateHandleMethod(rowData, fn) {
      if (rowData.processMode.length > 100) {
        this.$message.warning("处理方式长度不能大于100");
        return;
      }
      if (!rowData.processMode && rowData.processMode != "0") {
        this.$message.warning("处理方式名称不能为空");
        return;
      }
      let find = this.dealList.find(item => item.processMode == rowData.processMode && item.id != rowData.id);
      if (find) {
        this.$message.warning("处理方式名称不能相同");
        return;
      }

      this.$RequestUtil.post({
        url: "/api/eventProcessConfig/edit",
        type: "sync",
        params: {
          processMode: rowData.processMode,
          id: rowData.id
        },
        success: async res => {
          rowData.isEdit = false;
          this.disabledAdd = false;
          this.loadHandleMethod(this.selectAnomalyCode);
          fn && fn();
          this.$message.success("编辑成功");
        }
      });
    },

    // 加载事件处理列表
    async loadHandleMethod(anomalyCode) {
      let res = await this.$RequestUtil.getAsync({ url: "/api/eventProcessConfig/list", type: "sync", params: { anomalyCode } });
      if (res.code == 0) {
        res.data.forEach(item => {
          item.isEdit = false;
          item.isAdd = false;
        });
        this.dealList = res.data;
        this.disabledAdd = false;
      } else {
        this.$message.error(res.message || res.msg);
      }
    },

    // 删除事件处理方式
    deleteHandleMethod(rowData, index) {
      if (!rowData.id) {
        this.dealList.splice(index, 1);
        this.disabledAdd = false;
        return;
      }
      this.$confirm(`此操作将会删除此处理方式,是否继续?`, "提示", {
        cancelButtonClass: "btn-custom-cancel",
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.dealList.splice(index, 1);
        this.$RequestUtil.post({
          url: "/api/eventProcessConfig/del",
          type: "sync",
          params: {
            id: rowData.id
          },
          success: async res => {
            rowData.isEdit = false;
            this.disabledAdd = false;
            this.$message.success("删除成功");
          }
        });
      });
    }
  }
};
</script>
<style scoped>
.left-title {
  font-size: 16px;
  font-family: PingFangSC, PingFangSC-Medium;
  font-weight: bold;
  height: 60px;
  line-height: 62px;
  color: #242c34;
  padding-left: 15px;
}
</style>
<style>
.deal-config .el-menu.el-menu--horizontal {
  border: none;
}
.deal-config .el-menu--horizontal > .el-menu-item {
  height: 36px;
  line-height: 36px;
  font-size: 16px;
  font-family: "MiSans-Regular";
  color: #94a3b8;
}
.deal-config .el-menu--horizontal > .el-menu-item.is-active {
  color: #409eff;
}
</style>



// WEBPACK FOOTER //
// src/views/alarm/DealConfig.vue